import { eventsRequest } from '../../utils/eventsRequest';
import type { RequiredEventForm } from '../../types';

type AllFormsApiItem = {
  orderId: number;
  orderUuid: string;
  eventId: number;
  eventName?: string;
  formId: number;
  templateName?: string;
  childId: number;
  childName?: string;
  formSchema?: string;
  completed: boolean;
  completedAt?: string;
  submissionId?: number;
};

type AllFormsApiResponse = {
  statusCode: number;
  isSuccess: boolean;
  data: {
    hasOutstandingForms: boolean;
    remainingCount: number;
    forms: AllFormsApiItem[];
  };
};

export function mapAllFormsItemToRequiredEventForm(
  item: AllFormsApiItem
): RequiredEventForm {
  return {
    id: item.formId,
    formName: item.templateName ?? 'Form',
    eventName: item.eventName ?? '—',
    eventId: item.eventId,
    childId: item.childId,
    childName: item.childName,
    form: item.formSchema,
    completed: item.completed,
    completedAt: item.completedAt,
    submissionId: item.submissionId,
  };
}

/**
 * Fetches all required event forms (complete + incomplete) for the logged-in parent.
 */
const getUserAllForms = async (): Promise<AllFormsApiResponse | null> => {
  try {
    const response = await eventsRequest<AllFormsApiResponse>(
      '/orders/forms/all',
      'get'
    );
    if (response.status === 200 || response.status === 201) {
      return response.data;
    }
    return null;
  } catch (error) {
    console.error('❌ Error fetching all forms:', error);
    return null;
  }
};

export default getUserAllForms;

